import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation, useParams } from "react-router-dom";
import _ from "lodash";

function PrivateRoute(props) {
  let location = useLocation();
  let params = useParams();
  const [authorized, setAuthorized] = useState(true);
  const CheckIfAuthorized = async () => {
    let path = location.pathname;
    if (!_.isEmpty(params)) {
      let sub_params = Object.keys(params);
      path = path.substring(0, path.length - params[sub_params[0]].length - 1);
    }
    // First, find the 'url' responsible for the security permission
    let found_url = current_protected_routes.find((f) => f.url === path);
    // If the url is unable to be found, no authorization
    if (!found_url) return setAuthorized(false);
    if (found_url.always_allow === true) return setAuthorized(true);

    // Next, find teh security setting for that url.
    let security_setting = props?.securitySettings.find((f) => f.url === found_url?.security_setting_url);
    // If the security setting is unable to be found, no authorization
    if (!security_setting) return setAuthorized(false);

    // If they have view permissions
    if (security_setting?.viewable === 0) return setAuthorized(false);

    return setAuthorized(true);
  };
  // console.log(location, params);
  const current_protected_routes = [
    { url: "/clients", security_setting_url: "/clients" },
    { url: "/client-details", security_setting_url: "/clients" },

    { url: "/time-sheet", security_setting_url: "/time-sheet" },

    { url: "/task-board", security_setting_url: "/task-board" },

    { url: "/invoicing", security_setting_url: "/invoices" },
    { url: "/invoicing", security_setting_url: "/invoices" },
    { url: "/invoices", security_setting_url: "/invoices" },
    { url: "/invoice-preview", security_setting_url: "/invoices" },
    { url: "/invoice-preview/:invoice_tag", security_setting_url: "/invoices" },
    { url: "/invoice-preview-with-details", security_setting_url: "/invoices" },
    { url: "/invoice-preview-with-details/:invoice_tag", security_setting_url: "/invoices" },
    { url: "/bulk-invoice-preview", security_setting_url: "/invoices" },
    { url: "/invoice-details-preview", security_setting_url: "/invoices" },

    { url: "/payments", security_setting_url: "/payments" },

    { url: "/exports", security_setting_url: "/export-invoices" },
    { url: "/export-invoices", security_setting_url: "/export-invoices" },

    { url: "/reports/client-reports", security_setting_url: "/reports/client-reports" },

    { url: "/reports/time-reports", security_setting_url: "/reports/time-reports" },

    { url: "/reports/task-reports", security_setting_url: "/reports/task-reports" },

    { url: "/reports/invoice-reports", security_setting_url: "/reports/invoice-reports" },

    { url: "/items", security_setting_url: "/items" },

    { url: "/item-categories", security_setting_url: "/item-categories" },

    { url: "/job-statuses", security_setting_url: "/job-statuses" },

    { url: "/task-statuses", security_setting_url: "/task-statuses" },

    { url: "/billing-status-categories", security_setting_url: "/billing-status-categories" },

    { url: "/billing-statuses", security_setting_url: "/billing-statuses" },

    { url: "/adjustment-codes", security_setting_url: "/adjustment-codes" },

    { url: "/company-settings", security_setting_url: "/company-settings" },

    { url: "/users", security_setting_url: "/users" },

    { url: "/security-profiles", security_setting_url: "/security-profiles" },

    { url: "/billing-groups", security_setting_url: "/billing-groups" },

    { url: "/client-categories", security_setting_url: "/client-categories" },

    { url: "/email-outreach", security_setting_url: "/email-outreach" },
    { url: "/email-campaigns", security_setting_url: "/email-outreach" },

    { url: "/user-settings", security_setting_url: "", always_allow: true },
    { url: "/dashboard", security_setting_url: "", always_allow: true },

    { url: "/reports/user-summary", security_setting_url: "" },
    { url: "/reports/time-by-item", security_setting_url: "" },
    { url: "/reports/time-by-day", security_setting_url: "" },
  ];

  useEffect(() => {
    CheckIfAuthorized();
  }, [location]);
  if (!authorized) return <Navigate to="/clients" />;
  if (!props.authToken) return <Navigate to="/auth/login" />;
  return <Outlet {...props} />;
}

export default PrivateRoute;
